import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const DynamicsSelector = ({
  cdDynamicList = 0,
  setCdDynamicList = () => { },
  setRemoveModal = () => { },
  dynamicsSelected = [],
  translate = () => { },
  customQuantityPlural,
  customQuantitySingular,
  customRemovePlural,
  customRemoveSingular,
  customCancelText,
}) => {
  const renderOptions = () => {
    const list = [
      {
        label: 'remove',
        action: () => {
          setRemoveModal(dynamicsSelected);
        },
      },
      {
        label: 'cancel',
        action: () => {
          setCdDynamicList([]);
        },
      },
    ]

    return list.map(({ label, action }) => (
      <Fragment key={label}>
        {' '}
        |{' '}
        <span onClick={action} style={{ color: '#72BF44', cursor: 'pointer' }}>
          {label === 'remove'
            ? (cdDynamicList > 1
              ? (customRemovePlural || translate(`dynamic.selection.${label}Plural`))
              : (customRemoveSingular || translate(`dynamic.selection.${label}Singular`))
            )
            : (customCancelText || translate(`dynamic.selection.${label}${cdDynamicList > 1 ? 'Plural' : 'Singular'}`))
          }
        </span>
      </Fragment>
    ))
  }

  return (
    <div className='mission-block-action-mode'>
      {cdDynamicList > 0 && (
        <div style={{ marginTop: '1rem' }}>
          <strong>{`${cdDynamicList} ${cdDynamicList > 1
              ? (customQuantityPlural || translate(`dynamic.selection.quantityPlural`))
              : (customQuantitySingular || translate(`dynamic.selection.quantitySingular`))
            }`}</strong>
          {renderOptions()}
        </div>
      )}
    </div>
  )
}

DynamicsSelector.propTypes = {
  cdDynamicList: PropTypes.number.isRequired,
  handleSideFilterMenuCollapseChange: PropTypes.func.isRequired,
  setCdDynamicList: PropTypes.func.isRequired,
  sideFilterVisible: PropTypes.bool.isRequired,
  translate: PropTypes.func.isRequired,
  setRemoveModal: PropTypes.func.isRequired,
  dynamicsSelected: PropTypes.array,
  customQuantityPlural: PropTypes.string,
  customQuantitySingular: PropTypes.string,
  customRemovePlural: PropTypes.string,
  customRemoveSingular: PropTypes.string,
  customCancelText: PropTypes.string,
}

export default DynamicsSelector
